
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#F5A623"}},[_c('circle',{attrs:{"cx":"20","cy":"11","r":"6"}}),_c('circle',{attrs:{"cx":"8","cy":"14","r":"4"}}),_c('circle',{attrs:{"cx":"32","cy":"14","r":"4"}}),_c('rect',{attrs:{"x":"12","y":"21","width":"16","height":"15","rx":"5"}})]),_c('path',{attrs:{"d":"M2 25a6 6 0 0110-4 10 10 0 00-3 7v5H5a3 3 0 01-3-3v-5zm36 0a6 6 0 00-10-4 10 10 0 013 7v5h4a3 3 0 003-3v-5z","fill":"#F8D99C"}})])
          )
        }
      }
    